/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Saved_Presets_LabelInputs */



/**
* | output |
* | --- |
* | "Saved Presets" |
*
* @param {Preset_Manager_Saved_Presets_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_saved_presets_label = /** @type {((inputs?: Preset_Manager_Saved_Presets_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Saved_Presets_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Presets enregistres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeicherte Voreinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preimpostazioni salvate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраненные пресеты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes preestablecidos guardados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已保存的预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存されたプリセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहेजे गए प्रीसेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Predefinições salvas")
	return /** @type {LocalizedString} */ ("Saved Presets")
});